import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import { useHistory } from "react-router-dom";
import {fetchData}  from "../../utils/utils";

const PremiumPayment = ({ lang }) => {
  const [loading, setLoading] = useState(false);
//   const history = useHistory();

  useEffect(() => {
    const getPremiumPayment = async () => {
      setLoading(true);
      const result = await fetchData("customer-premium-payment", { customer_id: "1023" });

      if (result.success) {
        console.log("Response:", result.data);
      } else {
        console.error("Error fetching data:", result.error);
      }

      setLoading(false);
    };

    getPremiumPayment();
  }, []);

  return <div className="container mt-4">{loading && <p>Loading...</p>}</div>;
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(PremiumPayment);
